<template>
  <el-dialog title="" :visible.sync="visible" width="30%" append-to-body>
    <f-select :list="list" :value.sync="key" @submit="handleSubmit"></f-select>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      key: "",
      list: [],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(n) {
      n && this.init();
    },
  },
  computed: {
    ...mapGetters(["globalData"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
    // list() {
    //   return this.globalData.communities.map((v) => {
    //     return {
    //       name: v,
    //     };
    //   });
    // },
  },
  methods: {
    init() {
      this.key = "";
      let list = this.globalData.villages.map((v) => {
        return { name: v };
      });
      this.list = list;
    },
    handleSubmit() {
      this.$store.commit("app/SET_PLOT_KEY", this.key);
      this.$store.dispatch("app/getGlobalData").then((resp) => {
        if (!resp) {
          this.$store.commit("app/SET_PLOT_KEY", "");
          return;
        }
        this.$store.commit("app/SET_KEY", "house");
      });
      this.visible = false;
    },
  },
  mounted() {
    this.filterList = this.list;
  },
};
</script>
<style scoped lang="less">
.container {
  position: relative;
  .bg-img {
    position: absolute;
  }
  .content {
    position: relative;
    z-index: 2;
    color: #fff;
    padding-top: 6%;
    padding-left: 30px;
    padding-right: 30px;
    font-weight: bold;
    font-size: 20px;
  }
  .list__container {
    margin-top: 30px;
    height: 370px;
    overflow: scroll;
    .item {
      width: 100%;
      height: 39px;
      background: linear-gradient(
        90deg,
        #161f4e 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
      //   opacity: 0.28;

      font-size: 16px;
      color: #01b3e6;
      font-weight: 500;
    }
    .item:hover {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
    .active {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
  }
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-input__inner {
//     height: 42px;
//     border: 1px solid #077fd4;
//     border-radius: 8px;
//     background: none;
//     color: #01b3e6;
//   }
//   .el-dialog__header {
//     height: 20px;
//     padding: 0;
//   }
// }
</style>
